<template>
    <div class="review-wrapper">
        <div class="px-4 pt-4"><img class="mw-100 rounded" v-if="image" :src="image"/>
            <p class="my-4 text-center">{{ question_message }}</p>
        </div>
        <rating-stars class="rating-stars mt-4 d-flex flex-wrap justify-content-center" v-if="type === 'cx'"
                      v-model="rating" @input="onRate"></rating-stars>
        <rating-stars class="rating-stars mt-4 d-flex flex-wrap justify-content-center" v-if="type === 'nps'"
                      style="font-size: 1.8em" :stars="10" icon="fa-circle" color="#0374d7" :show-numbers="true"
                      v-model="rating" @input="onRate"></rating-stars>
        <div class="px-4 text-danger text-center"><small v-if="form.errors.has('rating')">Please leave you
            rating</small></div>
        <div class="px-4 pb-4">
            <likely v-if="type === 'nps'"></likely>
            <small class="text-center invalid-feedback" v-if="form.errors.has('rating')">{{ form.errors.get('rating')
                }}</small>
            <button-loading class="mt-2 btn btn-block btn-primary swell-btn" @click="$emit('submit', rating)"
                            :loading="form.submitting">{{ submit_text }}
            </button-loading>
        </div>
    </div>
</template>

<style lang="sass" scoped>
    @import '../../../sass/media'
    ::v-deep .star-wrapper
        margin-bottom: 5px
        font-size: 2.6rem

        @include respond-below(sm)
            margin-bottom: 15px
            font-size: 3.1rem

        .number
            font-size: 1rem
</style>

<script>
    import Likely from './components/Likely';

    export default {
        components: {Likely},

        props: {
            image: {default: ''},
            type: {default: 'cx'},
            submitText: {default: null},
            question: {default: null},
            value: {default: null},
            form: {default: () => new Form({rating: null})},
            error: {default: false}
        },

        mounted() {
            this.form.value = this.value;
        },

        data() {
            return {
                rating: this.value
            };
        },

        computed: {
            question_message() {
                return this.question || 'How would you rate your experience with us?';
            },
            submit_text() {
                return this.submitText || 'Submit';
            }
        },

        methods: {
            onRate(value) {
                this.rating = this.form.rating = value;
            }
        }
    };
</script>
